// @flow
import BaseCollection from "../base/BaseCollection";
import ModelCategoryModel from "./ModelCategoryModel";

import type { ModelCategory } from "./ModelCategoryModel";

/**
 * Model category collection
 */
export default class ModelCategoryCollection extends BaseCollection<ModelCategoryModel> {
  /**
   */
  constructor(modelCategories: Array<ModelCategory> = []) {
    super();

    this.collection = modelCategories
      ? modelCategories.map(
          (modelCategory) => new ModelCategoryModel(modelCategory),
        )
      : [];
  }
}
